import { defineComponent, inject, onMounted, onUpdated, ref } from 'vue';
import CatalogItem from '@/components/CatalogItem.vue';
import Spinner from '@/components/Spinner.vue';
import { CatalogOrder } from '@/services/api';
import { wcserviceClientKey } from '@/main';
import { getGtagCallbacks } from '@/gtag.utils';
import { GA4 } from '@/ga4';
export default defineComponent({
    name: 'SimpleCatalog',
    props: {
        config: {
            type: Object,
            required: true,
        },
    },
    components: {
        Spinner,
        CatalogItem,
    },
    setup(props) {
        const wcserviceClient = inject(wcserviceClientKey);
        if (wcserviceClient === undefined) {
            throw new Error('Cannot inject wcserviceClient');
        }
        const ga4Enabled = props.config.ga4.enabled;
        const ga4 = new GA4(props.config.ga4.listId ?? '', props.config.ga4.listName ?? '', props.config.ga4.brandFallback);
        const { gtagAddToCart, gtagSelectContent, gtagViewItemList } = getGtagCallbacks(props.config.gtag);
        const catalog = ref(null);
        const loading = ref(true);
        const products = ref([]);
        const loadProducts = async () => {
            loading.value = true;
            const taxonomies = {};
            if (props.config.taxonomies.length > 0) {
                for (const tax of props.config.taxonomies) {
                    taxonomies[tax.taxonomy] = { op: 'or', terms: tax.selectedTerms };
                }
            }
            products.value = await wcserviceClient.findProducts({
                limit: props.config.productIds.length,
                postMetaIn: ['_attribute_list', '_sku', '_wc_average_rating'],
                taxonomiesIn: ['product_cat', 'product_type', 'product_brand', 'selection_taxonomy'],
                termMetaIn: ['selection_badge'],
                order: CatalogOrder.Default,
                query: {
                    ids: props.config.productIds,
                    taxonomies,
                },
            });
            gtagViewItemList(products.value, 0);
            if (ga4Enabled) {
                ga4.viewItemList(products.value, 0);
            }
            loading.value = false;
        };
        const addToCart = (product, index) => {
            gtagAddToCart(product, index);
            if (ga4Enabled) {
                ga4.addToCart(product, index);
            }
        };
        const viewDetails = (product, index) => {
            gtagSelectContent(product, index);
            if (ga4Enabled) {
                ga4.selectItem(product, index);
            }
        };
        onMounted(() => {
            loadProducts();
        });
        onUpdated(() => {
            if (products.value.length > 0) {
                catalog.value?.dispatchEvent(new Event('catalogloaded', { bubbles: true }));
            }
        });
        return {
            // refs
            catalog,
            loading,
            products,
            // methods
            addToCart,
            viewDetails,
        };
    },
});
